/**
 * @module app.shared
 */

import { IApiQueryFilter } from './api-filters';
import { QueryEqualityOperator } from './api-types';
import { encodeFieldName, encodeStringLiteralArray, mapQueryStringComparisonOperator, encodeIdentifierLiteralArray } from './api-utilities';

export interface IQueryArrayFilterOptions {
    ignoreNullValue: boolean;
    negate: boolean;
    operator: QueryEqualityOperator;
}

export class ApiQueryStringArrayFilter implements IApiQueryFilter {

    constructor(public field: string, public values: string[], public options: IQueryArrayFilterOptions) { }

    public toString(): string {
        const operation = mapQueryStringComparisonOperator(this.options.operator, this.options.negate);
        const encodedField = encodeFieldName(this.field);
        const encodedValue = this.values.length === 0 ? 'null' : encodeStringLiteralArray(this.values);

        return operation.buildExpression(encodedField, encodedValue);
    }

}

export class ApiQueryIdentifierArrayFilter implements IApiQueryFilter {

    constructor(public field: string, public values: string[], public options: IQueryArrayFilterOptions) { }

    public toString(): string {
        const operation = mapQueryStringComparisonOperator(this.options.operator, this.options.negate);
        const encodedField = encodeFieldName(this.field);
        const encodedValue = this.values.length === 0 ? 'null' : encodeIdentifierLiteralArray(this.values);

        return operation.buildExpression(encodedField, encodedValue);
    }

}
